<template lang="pug">
  .sources
    p Sources:
    p &#185; <a href="https://nrf.com/media-center/press-releases/thanksgiving-weekend-multichannel-shopping-almost-40-percent-over-last" target="_blank">Smith, Ana Serafin, et al. “Thanksgiving Weekend Multichannel Shopping up Almost 40 Percent over Last Year.” NRF, Nov. 2018</a>
    p &#178; <a href="https://www.slideshare.net/NationalRetailFederation/holiday-2018-consumer-trends" target="_blank">NRF. “Holiday 2018 Consumer Trends.” NRF, Dec. 2018</a>
    p &#179; <a href="https://www.slideshare.net/adobe/adobe-digital-insights-holiday-recap-2018" target="_blank">Adobe. “Adobe Digital Insights Holiday Recap 2018.” Jan. 2019</a>
    p &#8308; <a href="https://nrf.com/insights/holiday-and-seasonal-trends/winter-holidays" target="_blank">NRF. “Retail Holidays and Seasonal Trends: Winter Holidays.” NRF. 2019</a>
    p &#8309; <a href="https://cmo.adobe.com/articles/2019/1/5-holiday-online-shopping-trends-to-guide-your-2019-strategy.html" target="_blank">Abramovich, Giselle. “5 Holiday Online Shopping Trends To Guide Your 2019 Strategy.” CMO by Adobe, Adobe, 2019</a>
    p &#8310; <a href="https://nrf.com/media-center/press-releases/young-adults-most-likely-spend-more-holiday-season" target="_blank">Smith, Ana Serafin. “Young Adults Most Likely to Spend More This Holiday Season.” NRF, Nov. 2018</a>
    p &#8311; <a href="https://nrf.com/sites/default/files/2019-01/Consumer%20View%20Winter%202018-2019_0.pdf " target="_blank">NRF. “2018/2019 Winter Consumer View,” PDF. 2019</a>
    p &#8312; <a href="https://solutions.ups.com/UPS-pulse-of-the-online-shopper-2019-LP.html?WT.mc_id=PRESSRELEASE_PRESSROOM_POTOS_STUDY_07301" target="_blank">UPS. “UPS Pulse of the Online Shopper 2019,” PDF. 2019</a>
    p &#8313; <a href="https://nrf.com/sites/default/files/2018-11/Natural-Insight-In-Store-Holiday-Shopping-2018.pdf" target="_blank">Natural Insight. “2018 In-store Holiday Shopping,” NRF. PDF. 2018</a>
    p &#185;&#8304; Weebly internal Ddata, 2018
    p &#185;&#185; Square internal Ddata, 2019
    p &#185;&#178; <a href="https://www2.deloitte.com/us/en/insights/industry/retail-distribution/holiday-retail-sales-consumer-survey.html" target="_blank">Sides, Rod, et al. “2018 Deloitte Holiday Retail Survey.” Deloitte Insights, Oct. 2018</a>
    p &#185;&#179; <a href="https://nrf.com/media-center/press-releases/procrastinators-rush-meet-holiday-deadline " target="_blank">Smith, Ana Serafin, et al. “Procrastinators Rush to Meet Holiday Deadline.” NRF, Dec. 2018</a>
    Logo
</template>

<script>
import Logo from '@/assets/img/svgs/square-logo.svg'

export default {
  name: 'sources',
  props: {
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  computed: {
  },
  methods: {
  },
  components: {
    Logo,
  },
}
</script>

<style scoped lang="scss">
.sources {
  padding: 6% 18%;
  position: relative;

  p {
    font-size: 1.06rem;
  }

  a {
    color: #000;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  svg {
    position: absolute;
    bottom: 9%;
    right: 6%;
    width: 7%;
  }

  @media #{$mobile} {
    padding:  6% 14%;
     p {
      font-size: 1.7rem;
    }
  }
}
</style>
